/**
 * @fileoverview Shared pdf.js entry point
 * @module utils/pdf/pdfjs
 *
 * Purpose:
 * - Single place that loads pdf.js and points it at its worker, so every
 *   feature that renders a PDF (letterhead extraction, document viewer,
 *   library thumbnails, PDF field editor) uses an identical setup.
 *
 * Why the `legacy/` build rather than the default one:
 * pdf.js 5.x's modern bundle calls `Map.prototype.getOrInsertComputed`,
 * a very recent TC39 "upsert" method, and ships no polyfill for it. On any
 * browser without native support this throws
 * `getOrInsertComputed is not a function` part-way through rendering — and
 * only for documents that reach that code path (pages resolving embedded
 * images or fonts), which makes it look like certain PDFs are corrupt. The
 * `legacy/` bundle carries the polyfill, for both the main thread and the
 * worker, and is otherwise the same renderer.
 *
 * Used by:
 * - utils/branding/extract-letterhead-images
 * - ui/composed/data-display/pdf-viewer
 * - components/jobs/phases/gather/library/pdfThumbnails
 * - components/settings/precedents/PdfFieldEditor
 */

import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.mjs";
import pdfjsWorkerUrl from "pdfjs-dist/legacy/build/pdf.worker.min.mjs?url";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorkerUrl;

export { pdfjsLib };
